import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DownloadingModalComponent } from '@app/shared/modals/downloading/downloading-modal.component';
import {
    ErrorInterface,
    ErrorLevelEnum,
    InternationalMotorInsuranceCardActionService,
    NewModal,
    PolicyValidityStatusCodeEnum,
    PurchasedProductInterface,
} from 'outshared-lib';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

const START_DATE_UNKNOWN = '9999-12-31';

@Component({
    selector: 'ins-insurance-imic-button-email',
    templateUrl: './insurance-imic-button-email.component.html',
    styleUrls: ['./insurance-imic-button-email.component.scss'],
})
export class InsuranceIMICButtonEmailComponent implements OnDestroy,  OnInit {
    @Input() public purchasedProduct!: PurchasedProductInterface;

    @Output() readonly loadSuccess: EventEmitter<boolean> = new EventEmitter();
    @Output() readonly loadError: EventEmitter<ErrorInterface[]> = new EventEmitter();

    public loading: boolean = false;
    public isDisabled = false;
    private subscriptions = new Subscription();

    constructor(
        private internationalMotorInsuranceCardActionService: InternationalMotorInsuranceCardActionService,
        private newModal: NewModal,
    ) {
    }

    public ngOnInit(): void {
        this.isDisabled = this.setDisabled();
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public requestInternationalMotorInsuranceCard(): boolean {
        const productSequenceNumber = this.purchasedProduct?.productSequenceNumber;
        const startDate = this.purchasedProduct?.product?.startDate;

        if (startDate === START_DATE_UNKNOWN) {
            return;
        }

        const modalRef = this.newModal.open(DownloadingModalComponent);
        const loadEmailInternationalMotorInsuranceCard = this.internationalMotorInsuranceCardActionService
            .loadEmailInternationalMotorInsuranceCard$(productSequenceNumber)
            .pipe(tap(() => modalRef.close()))
            .subscribe({
                next: () => this.onLoadEmailInternationalMotorInsuranceCardSuccess(),
                error: (errors) => this.onError(errors),
            });

        this.startLoading();
        this.subscriptions.add(loadEmailInternationalMotorInsuranceCard);
        return true;
    }

    private setDisabled(): boolean {
        return this.purchasedProduct?.product?.validityStatusCode === PolicyValidityStatusCodeEnum.Transfer;
    }

    private startLoading(): void {
        this.loading = true;
        this.loadError.emit([]);
        this.loadSuccess.emit(false);
    }

    private onLoadEmailInternationalMotorInsuranceCardSuccess(): void {
        this.loading = false;
        this.loadError.emit([]);
        this.loadSuccess.emit(true);
    }

    private onError(errors: ErrorInterface[]): void {
        this.loading = false;
        this.loadError.emit([{
            element: '',
            id: '',
            level: ErrorLevelEnum.Error,
            message: 'Er is iets misgegaan. Probeer het later nog eens.',
        }]);

        // Show errors in console
        console.error(errors);
    }
}
